export default "__VITE_ASSET__CIj4TB2T__"